import { action, extendObservable, reaction } from 'mobx';
import PropTypes from 'prop-types';
import FuseSearchTextStore from './FuseSearchTextStore';
import BulkEditorStore from './BulkEditorStore';

export default class UrlBulkEditorStore {
    static PropType = PropTypes.shape({
        bulkEditorStore: BulkEditorStore.PropType,
        fuseSearchTextStore: FuseSearchTextStore.PropType,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class UrlBulkEditorStore */{
            bulkEditorStore: new BulkEditorStore({
                ...(data.validators ? { validators: data.validators } : {}),
                ...(data.getCanonicalValue ? { getCanonicalValue: data.getCanonicalValue } : {}),
            }),
            width: null,
            margin: 40,
            fuseSearchTextStore: new FuseSearchTextStore({
                searchBack: () => this.bulkEditorStore.searchBack(),
                searchForward: () => this.bulkEditorStore.searchForward()
            }),
        }, data);


        reaction(() => this.fuseSearchTextStore.inputStore.value, this.bulkEditorStore.setSearch);

        reaction(() => this.bulkEditorStore.getSearchIndex(), this.fuseSearchTextStore.setSearchIndex);

        reaction(() => this.bulkEditorStore.searchCount, this.fuseSearchTextStore.setSearchCount);
    }

    updateWidth = action((width) => {
        this.width = width;
        this.bulkEditorStore.width = width - this.margin;
    });
}
